import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import clsx from 'clsx'

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  const languages = [
    { code: 'pt', name: 'Português', short: 'PT' },
    { code: 'en', name: 'English', short: 'EN' },
    { code: 'es', name: 'Español', short: 'ES' },
    { code: 'de', name: 'Deutsch', short: 'DE' },
  ]

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0]

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode)
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as="button" className="language-switcher-pill no-dropdown-arrow" id="language-switcher">
        <span>{currentLanguage.short}</span>
        <i className="bi bi-chevron-down opacity-50 ms-2" style={{ fontSize: '0.7rem' }}></i>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="cyber-dropdown-menu">
        {languages.map((language) => (
          <Dropdown.Item
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={clsx('cyber-dropdown-item', i18n.language === language.code && 'active')}
          >
            {language.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageSwitcher
